import { Component, OnInit, APP_BOOTSTRAP_LISTENER } from '@angular/core';
import { LabService } from 'src/app/services/lab.service';
import { HomeService } from 'src/app/services/home.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-lab-list',
  templateUrl: './lab-list.component.html',
  styleUrls: ['./lab-list.component.css']
})
export class LabListComponent implements OnInit {
  labList:any=[]
  cities:any=[]
  object:any={city:localStorage.getItem('currentcity') ? localStorage.getItem('currentcity').toLowerCase() :''}
  currentCity:String=localStorage.getItem('currentcity') ? localStorage.getItem('currentcity').toLowerCase() : ''
  constructor(public labSvc:LabService,
    private homeSvc:HomeService,
    private spinner: NgxSpinnerService,
    private auth:AuthService) { }

  ngOnInit() {
  
    this.getCities()
    this.getLocation()
  }
  getLocation(){
    this.auth.getLocation().then(location => {
    
     localStorage.setItem('lat',location.lat)
     localStorage.setItem('lng',location.lng)
      
     let objectSearch = {value:{name:'',city:'',tests:''}}
     this.getLabsList(objectSearch)
     
    
    })
  }
  selectEvent(item,form:NgForm) {
    console.log(item)
    this.object.city = item
    console.log(this.object)
    // do something with selected item
    form.value.city=item
    console.log(form.value)
    this.getLabsList(form)
  }
 
  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  
  onFocused(e){
  }
  getCities(){
    this.homeSvc.getCities('LABS').subscribe(res=>{
      this.cities = res["data"]
      if(localStorage.getItem('currentcity')){
        let arr =  this.cities.filter(city=>city.toLowerCase()==localStorage.getItem('currentcity').toLowerCase())
       // console.log(arr)
        if(arr.length==0)
           this.cities.push(localStorage.getItem('currentcity'))
       }
      },error=>{
  
      })
  }
  detectLocation(form:NgForm){
    this.object.city = this.currentCity ? this.currentCity.toLowerCase() : ''
    //console.log(this.object)
    // do something with selected item
    form.value.city=this.currentCity ? this.currentCity.toLowerCase() : ''
    console.log(form.value)
    this.getLabsList(form)
  }
  getLabsList(obj){
    this.spinner.show()
    this.labSvc.getLabsList(obj).subscribe(res=>{
      console.log(res);
      this.labList = res["data"]
      this.spinner.hide()
    },error=>{
      console.log(error);
    })
  }
  
  searchDoctorForm(form:NgForm){
  
 this.getLabsList(form)
  }

}
